/**
 * Constants for the Regulated Personnel form (EHOCM).
 * Used for role-based visibility of certification blocks.
 * Based on EMR-2095 Certificate Requirements table.
 */

/** Roles that do not require certifications to be displayed (EMR-2095: N/A) */
export const NO_CERT_ROLES: string[] = [
  "ACS MANAGER",
  "CACC DIRECTOR",
  "CACC MANAGER",
  "CEO",
  "CHIEF",
  "CLERK/ADMINISTRATOR",
  "COMMANDER",
  "CTO",
  "DEPUTY CHIEF",
  "DIRECTOR",
  "ID CARD CONTACT PERSON",
  "LPO",
  "MANAGER",
  "MECHANIC",
  "MEDICAL DIRECTOR",
  "OPERATIONS MANAGER",
  "ORGANIZATION ADMINISTRATOR",
  "PILOT",
  "PRESIDENT",
  "PROGRAM MANAGER - BASE HOSPITAL",
  "QA & COMPLIANCE",
  "QPO",
  "QUALITY IMPROVEMENT COORD",
  "QUALITY IMPROVEMENT COORD.",
  "QUALITY ASSURANCE",
  "SUPERINTENDENT",
  "SUPERVISOR",
  "UTM BOARD DESIGNATE",
  "LOGISTICS",
  "DISPATCHER",
  "COMMUNICATION",
  "SAFETY OFFICER",
  "IT PROFESSIONAL",
  "FINANCE",
  "HR",
  "LEGAL",
  "PUBLIC RELATIONS",
];

/** Map of block IDs to roles for which that block is visible */
export const VISIBLE_FOR_ROLE: Record<string, string[]> = {
  paramedic: ["ACP", "CCP", "PCP", "EMA"],
  cpr: [
    "PCP",
    "ACP",
    "CCP",
    "ACO 1",
    "ACO 2",
    "EMD",
    "SSC",
    "CO",
    "ECN",
    "EMA",
  ],
  firstAid: [
    "PCP",
    "ACP",
    "CCP",
    "ACO 1",
    "ACO 2",
    "EMD",
    "SSC",
    "CO",
    "ECN",
    "EMA",
  ],
  tdg: ["NURSE", "PHYSICIAN", "RESPIRATORY THERAPIST", "PCP", "ACP", "CCP"],
  aeromed: [
    "NURSE",
    "PHYSICIAN",
    "RESPIRATORY THERAPIST",
    "PCP",
    "ACP",
    "CCP",
    "EMA",
  ],
  aircraft: [
    "NURSE",
    "PHYSICIAN",
    "RESPIRATORY THERAPIST",
    "PCP",
    "ACP",
    "CCP",
    "EMA",
  ],
  baseHospital: ["PCP", "ACP", "CCP"],
  aco: ["ACO 1", "ACO 2", "EMD", "SSC", "CO", "ECN"],
  ecn: ["ECN"],
  licence: ["NURSE", "PHYSICIAN", "RESPIRATORY THERAPIST"],
};

/** Set of known block IDs used for certification section visibility */
export const KNOWN_BLOCK_IDS = new Set([
  "paramedic",
  "cpr",
  "firstAid",
  "tdg",
  "aeromed",
  "aircraft",
  "baseHospital",
  "aco",
  "ecn",
  "licence",
  "buttons",
]);
